import { SystemCatalog  } from '../shared/index';
// import { isNull } from "../utils/index";
// import { STATICLANGUAGEWINDOW } from "../core/index";

export interface I18nData {
    /**
     * locale yang di pilih saat ini
     */
    currentLocaleCode: string ; 

    /**
     * katalog internalization
     */
    internalizations: {[id: string]: {[id: string]: SystemCatalog.I18nText }}; 
}

export const APP_I18N_DATA: I18nData = {
    currentLocaleCode: 'KOR' , 
    internalizations: {}
};
/**
 * membaca label translate
 * @param key key i18n key
 * @param defaultText label default untuk di munculkan kalau misal tidak ada terjemahan
 */
export function i18n(key: string , defaultText: string ): string  {
    if (!APP_I18N_DATA.internalizations[APP_I18N_DATA.currentLocaleCode] || !APP_I18N_DATA.internalizations[APP_I18N_DATA.currentLocaleCode][key] ) {
        return defaultText ; 
    }
    return APP_I18N_DATA.internalizations[APP_I18N_DATA.currentLocaleCode][key].text! ;
    
}

/**
 * push data ke dlaam translation
 * @param languageCode kode bahasa
 * @param translations terjemahan utnuk di pus
 */
export function appendTranslations(languageCode: string , translations: SystemCatalog.I18nText[] ) {
    if ( !translations || translations.length === 0 ) {
        return ; 
    }
    if ( !APP_I18N_DATA.internalizations[APP_I18N_DATA.currentLocaleCode] ) {
        APP_I18N_DATA.internalizations[APP_I18N_DATA.currentLocaleCode] = {} ;
        let cntr: {[id: string]: SystemCatalog.I18nText } = APP_I18N_DATA.internalizations[APP_I18N_DATA.currentLocaleCode]; 
        translations.forEach( t => {
            cntr[t.key!] = t ; 
        });
    }

} 


// WEBPACK FOOTER //
// ./src/utils/i18n-utils.ts